// extracted by mini-css-extract-plugin
export default {"backButton":"fCVMmsFZnYVzig0KvK6f"};